import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { RendimentoMensalNegociadores } from './RendimentoMensalNegociadores';

function RendimentoMensalNegociadoresPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Rendimento Mensal Negociadores'));
  return (
    <RendimentoMensalNegociadores />
  );
}

export default withTokenInterceptor(RendimentoMensalNegociadoresPage);
